import React from 'react';
import styles from './CRTOverlay.module.css';

function CRTOverlay() {
  return <div className={styles.overlay} aria-hidden="true" />;
}

export default CRTOverlay;
